<template>
  <div class='rf-tabela-edicao-geral' :data-time='time'>
    <!-- CRIA A TABELA -->
    <div style="clear: both; padding-top: 10px;" v-if='Object.keys(tabela).length >= 1 && time !== ""'>
      <RF-Tabela :data-time='time' style='overflow-x: auto;'
        :cpntTime='time'
        :cpntId='tabela.id'
        :cpntStatus='tabela.status'
        :cpntButtonImprimir='tabela.acoes.btImprimir'
        :cpntButtonAtualizar='tabela.acoes.btAtualizar'
        :cpntFraseTop='tabela.fraseTop'
        :cpntColuna='tabela.coluna'
        :cpntLinha='tabela.linha'
        :cpntCountAll='tabela.countAll'
        :cpntColspan='tabela.colspan'
        :cpntButtonsAcoes='tabela.acoes.buttons'
        :cpntMper='tabela.mper'
        :cpntPagina='tabela.pagina'

        :ref='tabela.id'
      ></RF-Tabela>
        <!-- 
        :cpntOnRefreshTabela='iniciarTabela'
        :cpntOnCheckboxAtualiza='onCheckboxAtualiza'
        -->

        <!-- 
        <RF-Tabela 
        :cpntId='tabela.id'
        :cpntStatus='tabela.status'
        :cpntMper='tabela.mPer'
        :cpntColuna='tabela.coluna'
        :cpntLinha='tabela.linha'
        :cpntButtonsAcoes='tabela.buttonsAcoes'
        :cpntEditar='tabela.editar'
        :cpntButtonImprimir='tabela.buttonImprimir'
        :cpntButtonAtualizar='tabela.buttonAtualizar'
        :cpntPagina='tabela.pagina'
        :cpntCountAll='tabela.countAll'
        ></RF-Tabela>
        -->
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      cpntId: {
        type: Array,
        required: true
      }
    },
    data: function () {
      return {
        time: 0,
        tabela: {}
      }
    },
    mounted: function () {
      this.iniciarTabela()
    },
    methods: {
      // FUNÇOES INICIAIS DA TABELA
      // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
      iniciarTabela: function () {
        var self = this

        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        self.tabela = {
          status: 'carregando',
          id: 'tab-ser-edt-varios',
          api: {
            router: '/servico/get',
            method: 'POST',
            where: { aAnd: [ { f: 'id', o: 'in', v: self.cpntId.join() } ] }
          }
        }

        // INFORMA TODAS AS COLUNAS DA TABELA
        self.tabela.colunaAll = [
          { mPer: 3, chave: 'id', nome: 'Cod.', fieldApi: { id: null } },
          { mPer: 3, chave: 'nome', nome: 'Nome', fieldApi: { nome: null } },
          { mPer: 3, chave: 'id_cat_nome', nome: 'Categoria', fieldApi: { id_cat: { j: { nome: null } } } },
          { mPer: 3, chave: 'tp_valor', nome: 'Tipo de Valor', fieldApi: { valor: null, tp_valor: null } },
          { mPer: 3, chave: 'valor', nome: 'Valor do Serviço', fieldApi: { valor: null, tp_valor: null }, converte: { tipo: 'valorMoeda' } },
          // { mPer: 3, chave: 'obs', nome: 'Observação', fieldApi: { obs: null } },
          { mPer: 3, chave: 'rf-ult-alt', nome: 'Última Alteração', fieldApi: { last_at: null, last_user: { j: { usuario: null } } } }
        ]

        // FAZ A MONTAGEM DAS INFORMAÇÕES PARA TABELA
        self.$store.state.FUN_TABELA_CRIAR_DADOS(self.tabela, function (tabelaSuccess) {
          // SETA OS DADOS RECEBIDOS PARA TABELA
          self.tabela = tabelaSuccess

          // REALIZA O FOR PARA CRIAR OS CAMPOS PERSONALIZADOS
          for (var key in self.tabela.linha) {
            if (self.tabela.linha[key].hasOwnProperty('last_user')) {
              self.tabela.linha[key]['rf-ult-alt'] = [ self.tabela.linha[key]['last_user_usuario'] + '<br/>' + self.tabela.linha[key]['last_at_ptbr'] ]
            }

            if (self.tabela.linha[key].hasOwnProperty('tp_valor')) {
              if (self.tabela.linha[key].tp_valor === '1') {
                var value = self.tabela.linha[key].valor

                while ((value.indexOf('.') > -1 || value.indexOf(',') > -1)) {
                  value = value.replace(',', '')
                  value = value.replace('.', '')
                }

                self.tabela.linha[key].valor = (value / 100 + '%')
              }

              self.tabela.linha[key].tp_valor = self.tabela.linha[key].tp_valor === '0' ? 'R$' : '% do Total da Venda'
            }
          }

          // SETA O STATUS
          self.tabela.status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        }, function (tabelaError) {
          // SETA OS DADOS RECEBIDOS PARA TABELA
          self.tabela.status = tabelaError

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        })
      },
      finalizarTabela: function (tabela) {
        this.tabela = tabela

        if (this.tabela.status === 'carregando') {
          var aOptions = []
          for (var val = 0; val <= 100; val++) {
            aOptions.push({ value: val })
          }

          for (var key1 in this.tabela.linha) {
            if (this.tabela.linha[key1].hasOwnProperty('last_user')) {
              this.tabela.linha[key1]['rf-ult-alt'] = this.tabela.linha[key1]['last_user_usuario'] + '<br/>' + this.tabela.linha[key1]['last_at_ptbr']
            }

            if (this.tabela.linha[key1].tp_valor === '0') {
              this.tabela.linha[key1]['rf-tp_valor'] = 'R$'
            } else if (this.tabela.linha[key1].tp_valor === '1') {
              this.tabela.linha[key1]['rf-tp_valor'] = '% do Total da Venda'
            } else {
              this.tabela.linha[key1]['rf-tp_valor'] = '<span style=\'color: red;\'>WEB [500]: Erro ao identificar o tipo de valor (' + this.tabela.linha[key1].tp_valor + ').</span>'
            }

            if (this.tabela.linha[key1].tp_valor === '0') {
              this.tabela.linha[key1]['rf-valor'] = (this.tabela.linha[key1]['valor'] / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

              this.tabela.linha[key1]['rf-tp_valor'] = 'R$'
            } else if (this.tabela.linha[key1].tp_valor === '1') {
              this.tabela.linha[key1]['rf-valor'] = this.tabela.linha[key1].valor + '%'
            }
          }

          // SETA O STATUS PARA TABELA
          this.tabela.status = ''
        }

        // SETA O TIME PARA FORÇA A ATUALIZAÇÃO DO COMPONENT
        this.time = new Date().getTime()
      }
    },
    watch: {
      'cpntId': function () {
        this.iniciarTabela()
      }
    }
  }
</script>

<style scoped>
  .rf-tabela-edicao-geral {
    font-weight: normal !important;

    width: 100%;
    overflow-x: auto;
    max-height: 200px;
  }
</style>
